var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotibell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-bell",
    transform: "translate(-3 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M23.778,21.2H4.222a1.219,1.219,0,0,1-1.182-.894,1.191,1.191,0,0,1,.58-1.35,3.614,3.614,0,0,0,1.824-2.633V12.8q0-.028,0-.056a9.56,9.56,0,0,1,4.973-7.917,3.682,3.682,0,0,1,7.163,0,9.56,9.56,0,0,1,4.973,7.917q0,.028,0,.056v3.522a3.614,3.614,0,0,0,1.824,2.633,1.191,1.191,0,0,1,.58,1.35A1.219,1.219,0,0,1,23.778,21.2ZM7.116,18.8H20.884a5.917,5.917,0,0,1-.764-2.256,1.178,1.178,0,0,1-.009-.144V12.829a7.184,7.184,0,0,0-4.189-6.144,1.2,1.2,0,0,1-.7-1.085,1.223,1.223,0,0,0-2.444-.019,1.186,1.186,0,0,1-.188.658,1.2,1.2,0,0,1-.37.368,1.227,1.227,0,0,1-.165.088,7.183,7.183,0,0,0-4.166,6.134V16.4a1.178,1.178,0,0,1-.009.144A5.917,5.917,0,0,1,7.116,18.8Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M12.889,23.2A4.851,4.851,0,0,1,8,18.4V17.2a1.222,1.222,0,0,1,2.444,0v1.2a2.445,2.445,0,0,0,4.889,0V17.2a1.222,1.222,0,0,1,2.444,0v1.2A4.851,4.851,0,0,1,12.889,23.2Z",
    transform: "translate(1.111 2.8)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotibell);
export default __webpack_public_path__ + "static/media/Notibell.e3f89d58de58bf20f41723881ceccb63.svg";
export { ForwardRef as ReactComponent };